import { serverResponse } from 'app'
import Match from 'global-utils/models/sports/soccer/Match'

import * as actions from './TournamentActions'

export default (state = actions.getInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TOURNAMENT_FETCH: {
      return {
        ...state,
        id: action.payload,
        loaded: false,
        loading: true,
      }
    }
    case actions.TOURNAMENT_FETCH_CANCELED: {
      return { ...state, loading: false }
    }
    case actions.TOURNAMENT_FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        loaded: true,
      }
    }
    case actions.TOURNAMENT_FETCH_FULFILLED: {
      const newState = serverResponse(state, { ...action.payload, loaded: true })
      if (newState?.data?.[0]?.tournament?.stages?.length) {
        newState.data[0].tournament.stages = newState.data[0].tournament.stages.map((stage) =>
          Object.assign(stage, {
            rounds: stage.rounds.map((round) => {
              const matches = round.matches.map((match) => new Match(match))
              return Object.assign(round, { matches, stage })
            }),
          }),
        )
      }
      return newState
    }
    case actions.TOURNAMENT_LAST_VIEWED: {
      return { ...state, lastViewed: action.payload }
    }

    case actions.TOURNAMENT_PLAYERS_STATS_FETCH: {
      const newState = { ...state }
      newState.playersStats = serverResponse(
        {},
        {
          id: action.payload,
          loading: true,
        },
      )
      return newState
    }
    case actions.TOURNAMENT_PLAYERS_STATS_FETCH_CANCELED: {
      const newState = { ...state }
      newState.playersStats = serverResponse()
      return newState
    }
    case actions.TOURNAMENT_PLAYERS_STATS_FETCH_ERROR: {
      const newState = { ...state }
      newState.playersStats = serverResponse(newState.playersStats, {
        ...action.payload,
        loaded: true,
      })
      return newState
    }
    case actions.TOURNAMENT_PLAYERS_STATS_FETCH_FULFILLED: {
      const newState = { ...state }
      newState.playersStats = serverResponse(newState.playersStats, {
        ...action.payload,
        loaded: true,
      })
      return newState
    }

    case actions.TOURNAMENT_RANGE_MATCHES_FETCH: {
      const newState = { ...state }
      newState.matches = serverResponse(action.payload, { loading: true })
      return newState
    }
    case actions.TOURNAMENT_RANGE_MATCHES_FETCH_CANCELED: {
      const newState = { ...state }
      newState.matches = serverResponse()
      return newState
    }
    case actions.TOURNAMENT_RANGE_MATCHES_FETCH_ERROR: {
      const newState = { ...state }
      newState.matches = serverResponse({}, { error: action.payload, loaded: true })
      return newState
    }
    case actions.TOURNAMENT_RANGE_MATCHES_FETCH_FULFILLED: {
      const newState = { ...state }
      newState.matches = serverResponse(newState.matches, { ...action.payload, loaded: true })

      if (newState.matches.data[0]) {
        newState.matches.data[0].matches.forEach((match, index) => {
          newState.matches.data[0].matches[index] = new Match(match)
        })
      }
      return newState
    }

    default:
  }
  return state
}
